import { useState } from "react";
import { Trash2, Plus, Minus } from "lucide-react";
import FloatingBubble from "../FloatingBubble";
import ColorPopover from "../ColorPopover";
import "./Bubbles.css";

export default function TableBubble({ anchorEl, cell, iframeEl, onClose, onChange }) {
  const table = anchorEl;
  const [bgOpen, setBgOpen] = useState(false);

  const rowOf = (c) => c?.closest("tr");

  const addRow = (after) => {
    const tr = rowOf(cell);
    if (!tr) return;
    const newTr = tr.cloneNode(false);
    Array.from(tr.children).forEach((td) => {
      const newTd = td.cloneNode(false);
      newTd.innerHTML = "&nbsp;";
      newTr.appendChild(newTd);
    });
    if (after) tr.parentNode.insertBefore(newTr, tr.nextSibling);
    else tr.parentNode.insertBefore(newTr, tr);
    onChange();
  };

  const addCol = (after) => {
    if (!cell) return;
    const colIdx = Array.from(rowOf(cell).children).indexOf(cell);
    table.querySelectorAll("tr").forEach((tr) => {
      const ref = tr.children[colIdx];
      const newTd = table.ownerDocument.createElement(ref?.tagName === "TH" ? "th" : "td");
      newTd.style.cssText = "border:1px solid #e2e8f0;padding:8px;";
      newTd.innerHTML = "&nbsp;";
      if (after && ref) tr.insertBefore(newTd, ref.nextSibling);
      else if (ref) tr.insertBefore(newTd, ref);
      else tr.appendChild(newTd);
    });
    onChange();
  };

  const deleteRow = () => {
    const tr = rowOf(cell);
    if (tr && tr.parentNode.children.length > 1) tr.parentNode.removeChild(tr);
    onChange();
  };

  const deleteCol = () => {
    if (!cell) return;
    const colIdx = Array.from(rowOf(cell).children).indexOf(cell);
    const rows = table.querySelectorAll("tr");
    if (rows[0]?.children.length <= 1) return;
    rows.forEach((tr) => { if (tr.children[colIdx]) tr.removeChild(tr.children[colIdx]); });
    onChange();
  };

  const deleteTable = () => { table.parentNode?.removeChild(table); onChange(); onClose(); };

  const setCellBg = (color) => { if (cell) cell.style.backgroundColor = color; onChange(); };

  return (
    <FloatingBubble anchorEl={cell || table} iframeEl={iframeEl} label="Table" onClose={onClose}>
      <div className="bubble-row">
        <button type="button" className="bubble-btn" onClick={() => addRow(false)}><Plus size={12} /> Row ↑</button>
        <button type="button" className="bubble-btn" onClick={() => addRow(true)}><Plus size={12} /> Row ↓</button>
        <button type="button" className="bubble-btn danger" onClick={deleteRow}><Minus size={12} /> Row</button>
      </div>
      <div className="bubble-row">
        <button type="button" className="bubble-btn" onClick={() => addCol(false)}><Plus size={12} /> Col ←</button>
        <button type="button" className="bubble-btn" onClick={() => addCol(true)}><Plus size={12} /> Col →</button>
        <button type="button" className="bubble-btn danger" onClick={deleteCol}><Minus size={12} /> Col</button>
      </div>
      <div className="bubble-color-popover-wrap">
        <button type="button" className="bubble-color-trigger" onClick={() => setBgOpen((v) => !v)}>
          <span className="bubble-color-swatch" style={{ background: cell?.style?.backgroundColor || "#ffffff" }} />
          Cell BG
        </button>
        {bgOpen && <ColorPopover value={cell?.style?.backgroundColor || "#ffffff"} onChange={setCellBg} onClose={() => setBgOpen(false)} />}
      </div>
      <div className="bubble-actions">
        <button type="button" className="bubble-btn danger" onClick={deleteTable}><Trash2 size={12} /> Delete table</button>
      </div>
    </FloatingBubble>
  );
}
